import moment from "moment";
import { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { LazyLoadImage } from "react-lazy-load-image-component";
import downarrow from "../../assets/downarrow.png";
import uparrow from "../../assets/uparrow.png";
import DeleteCard from "../../Components/Cards/DeleteCard/DeleteCard";
import Advertisment_Form from "../../Components/Forms/Advertisment/Advertisment_Form";
import { useSearch } from "../../context/SearchContext";
import api from "../../utils/api";
import "./Advertisment.css";

const Advertisment = () => {
  const { search } = useSearch();
  const [display1, setDisplay1] = useState(0);
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [editData, setEditData] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [del, setDel] = useState(0);
  const [delId, setDelId] = useState(0);
  const [sortBy, setSortBy] = useState("asc");
  const [showDateFilter, setShowDateFilter] = useState(false);
  const [dateFilter, setDateFilter] = useState({ from: "", to: "" });
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 10,
    total: 0,
    totalPages: 0,
  });

  const handleClick1 = () => {
    setIsEdit(false);
    setEditData({});
    setDisplay1(1);
  };

  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  const fetchData = async () => {
    const response = await api.get(`/advertisements?search=${search}&page=${pagination.page}&limit=${pagination.limit}`);
    let data = response.data?.data;
    // data = data.filter((el) => new Date() <= new Date(el["from_dt"]));
    setData(data);
    setPagination(response?.data?.pagination);
  };

  useEffect(() => {
    fetchData();
  }, [search, pagination.page, pagination.limit]);

  // fetch(`${process.env.REACT_APP_BASE_URL}/advertisements`)
  //   .then((response) => response.json())
  //   .then((data) => {
  //     console.log(data);
  //     data = data.filter(
  //       (el) =>
  //         new Date() >= new Date(el["from_dt"]) &&
  //         new Date(el["to_dt"]) >= new Date()
  //     );
  //     setData(data);
  //   });
  // }, []);

  // Search and filter logic
  useEffect(() => {
    let temp = [...data];

    // Search filter
    if (search) {
      temp = temp.filter((item) =>
        Object.values(item)
          .join(" ")
          .toLowerCase()
          .includes(search.toLowerCase())
      );
    }

    // Date range filter
    if (showDateFilter && dateFilter.from && dateFilter.to) {
      temp = temp.filter((item) => {
        const from = moment(item.from_dt);
        const to = moment(item.to_dt);
        return (
          from.isSameOrAfter(dateFilter.from) &&
          to.isSameOrBefore(dateFilter.to)
        );
      });
    }

    // Sort
    temp.sort((a, b) => {
      const aDate = moment(a.from_dt);
      const bDate = moment(b.from_dt);
      return sortBy === "asc" ? aDate - bDate : bDate - aDate;
    });

    setFilteredData(temp);
  }, [data, search, showDateFilter, dateFilter, sortBy]);

  // Delete handler
  const handleDelete = async (id) => {
    await api.delete(`/advertisements/${id}`);
    toast.success("Advertisement deleted!");
    fetchData();
    setDel(0);
  };

  // After edit, refetch data
  const handleFormClose = () => {
    setDisplay1(0);
    setIsEdit(false);
    fetchData();
  };

  const handlePageChange = (newPage) => {
    setPagination((prev) => ({
      ...prev,
      page: newPage,
    }));
  };

  return (
    <div className="advertisment-div">
      {/* Search and filter */}
      <div>
        {/* <input
          type="text"
          placeholder="Search all fields..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          style={{ padding: "0.5rem", width: "250px" }}
        /> */}
        {/* <button onClick={() => setShowDateFilter((v) => !v)}>
          {showDateFilter ? "Hide Date Filter" : "Show Date Filter"}
        </button> */}
        {showDateFilter && (
          <>
            <input
              type="date"
              value={dateFilter.from}
              onChange={(e) =>
                setDateFilter((prev) => ({ ...prev, from: e.target.value }))
              }
            />
            <input
              type="date"
              value={dateFilter.to}
              onChange={(e) =>
                setDateFilter((prev) => ({ ...prev, to: e.target.value }))
              }
            />
          </>
        )}
      </div>

      {/* Form */}
      {display1 ? (
        <Advertisment_Form
          setDisp={() => {
            setDisplay1(0);
          }}
          fetchData={fetchData}
          data={editData}
          isEdit={isEdit}
          setEdit={() => setIsEdit(false)}
          mode="all" // Pass mode to enable all Zod validations
        />
      ) : null}

      {/* Delete confirmation */}
      {del ? (
        <DeleteCard del={() => handleDelete(delId)} close={() => setDel(0)} />
      ) : null}

      <div className="advertisment__top">
        <div className="advertisment__top_button_left_most">
          <button
            type="button"
            className="advertisment__top_button_advertisment advertisment__top_button_go"
            onClick={() => {
              setEditData({});
              setIsEdit(false);
              setDisplay1(1);
            }}
          >
            Add advertisment
          </button>
        </div>
      </div>
      <div className="advertisment__middle">
        <table>
          <thead>
            <tr className="advertisment__middle_tr">
              <th className="advertisment__middle_th">
                From Date - To Date{" "}
                {sortBy === "asc" ? (
                  <img
                    src={uparrow}
                    alt="uparrow"
                    style={{
                      height: 20,
                      width: 20,
                      marginBottom: -5,
                      marginLeft: 10,
                    }}
                    onClick={() => setSortBy("desc")}
                  />
                ) : (
                  <img
                    src={downarrow}
                    alt="downarrow"
                    style={{
                      height: 20,
                      width: 20,
                      marginBottom: -5,
                      marginLeft: 10,
                    }}
                    onClick={() => setSortBy("asc")}
                  />
                )}
              </th>
              <th className="advertisment__middle_th">Advertiser Name</th>
              <th className="advertisment__middle_th">Advertiser Banner</th>
              <th className="advertisment__middle_th">Advertiser PDF</th>
              <th className="advertisment__middle_th">Advertiser Description</th>
              <th className="advertisment__middle_th"></th>
            </tr>
          </thead>
          <tbody>
            {filteredData?.map((data, index) => {
              return (
                <tr className="advertisment__middle_tr" key={index}>
                  <td className="advertisment__middle_td">
                    {data.from_dt ? moment(data.from_dt).format("DD-MM-YYYY") : "-"} - {data.to_dt ? moment(data.to_dt).format("DD-MM-YYYY") : "-"}
                  </td>
                  <td className="advertisment__middle_td">{data.name || "-"}</td>
                  <td className="advertisment__middle_td banner">
                    {data.banner
                      ? (() => {
                          try {
                            const bannerObj = JSON.parse(data.banner);
                            const url = bannerObj.url || "";

                            return (
                              <LazyLoadImage
                                src={url}
                                alt=""
                                style={{
                                  width: "100px",
                                  height: "35px",
                                  borderRadius: "10px",
                                  objectFit: "cover",
                                }}
                              />
                            );
                          } catch (e) {
                            return "-";
                          }
                        })()
                      : "-"}
                  </td>
                  <td className="advertisment__middle_td">
                    {data.pdf
                      ? (() => {
                          try {
                            const pdfObj = JSON.parse(data.pdf);
                            const url = pdfObj.url || "";
                            const fileName = pdfObj.name || "";

                            const isPDF = url.toLowerCase().includes(".pdf") || fileName.toLowerCase().endsWith(".pdf") || url.toLowerCase().includes("pdf");

                            if (isPDF) {
                              return (
                                <a
                                  href={url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  style={{
                                    display: "inline-block",
                                    padding: "8px 12px",
                                    backgroundColor: "#ffaa2b",
                                    color: "white",
                                    textDecoration: "none",
                                    borderRadius: "5px",
                                    fontSize: "14px",
                                    fontWeight: "500",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    textAlign: "center",
                                    margin: "0 auto",
                                  }}
                                >
                                  📄 View PDF
                                </a>
                              );
                            }
                            return "-";
                          } catch (e) {
                            return "-";
                          }
                        })()
                      : "-"}
                  </td>
                  <td className="advertisment__middle_td" style={{ whiteSpace: "pre-wrap" }}>
                    {data.description || "-"}
                  </td>
                  <td className="advertisment__middle_td">
                    <button
                      type="button"
                      className="advertisment__middle_td_edit"
                      onClick={() => {
                        setIsEdit(true);
                        setEditData(data);
                        setDisplay1(1);
                      }}
                    >
                      Edit
                    </button>
                    <button
                      type="button"
                      className="advertisment__middle_td_delete"
                      onClick={() => {
                        setDel(1);
                        setDelId(data.id);
                      }}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {/* Pagination Controls */}
      <div
        className="pagination-controls"
        style={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          marginTop: "20px",
          gap: "10px",
        }}
      >
        <button
          onClick={() => handlePageChange(pagination.page - 1)}
          disabled={pagination.page === 1}
          style={{
            padding: "5px 10px",
            cursor: pagination.page === 1 ? "not-allowed" : "pointer",
            opacity: pagination.page === 1 ? 0.5 : 1,
          }}
        >
          Previous
        </button>

        <span>
          Page {pagination.page} of {pagination.totalPages}
        </span>

        <button
          onClick={() => handlePageChange(pagination.page + 1)}
          disabled={pagination.page === pagination.totalPages}
          style={{
            padding: "5px 10px",
            cursor:
              pagination.page === pagination.totalPages
                ? "not-allowed"
                : "pointer",
            opacity: pagination.page === pagination.totalPages ? 0.5 : 1,
          }}
        >
          Next
        </button>

        <div style={{ marginLeft: "20px" }}>
          <label htmlFor="limit-select" style={{ marginRight: "10px" }}>
            Items per page:
          </label>
          <select
            id="limit-select"
            value={pagination.limit}
            onChange={(e) => {
              setPagination((prev) => ({
                ...prev,
                limit: Number(e.target.value),
                page: 1, // Reset to first page when changing limit
              }));
            }}
            style={{
              padding: "5px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              backgroundColor:"rgb(239,239,239)",
            }}
          >
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default Advertisment;
